/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 22L3 18M7 22L11 18M7 22V14M7 3V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21 4V5.2C21 6.88016 21 7.72024 20.673 8.36197C20.3854 8.92646 19.9265 9.3854 19.362 9.67302C18.7202 10 17.8802 10 16.2 10H16M19 22V14L16.5 16.5M19 22H21M19 22H17M21 4V4C21 2.89543 20.1046 2 19 2H18C16.8954 2 16 2.89543 16 4V4C16 5.10457 16.8954 6 18 6H19C20.1046 6 21 5.10457 21 4Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="16"
				y="2"
				width="5"
				height="4"
				rx="2"
				fill="currentColor"
			/>
			<path
				d="M21 4V5.2C21 6.88016 21 7.72024 20.673 8.36197C20.3854 8.92646 19.9265 9.3854 19.362 9.67302C18.7202 10 17.8802 10 16.2 10H16M7 22L3 18M7 22L11 18M7 22V14M7 3V10M19 22V14L16.5 16.5M19 22H21M19 22H17M21 4V4C21 2.89543 20.1046 2 19 2H18C16.8954 2 16 2.89543 16 4V4C16 5.10457 16.8954 6 18 6H19C20.1046 6 21 5.10457 21 4Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M21 4V5.2C21 6.88016 21 7.72024 20.673 8.36197C20.3854 8.92646 19.9265 9.3854 19.362 9.67302C18.7202 10 17.8802 10 16.2 10H16M7 22L3 18M7 22L11 18M7 22V14M7 3V10M19 22V14L16.5 16.5M19 22H21M19 22H17M21 4V4C21 2.89543 20.1046 2 19 2H18C16.8954 2 16 2.89543 16 4V4C16 5.10457 16.8954 6 18 6H19C20.1046 6 21 5.10457 21 4Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M21 4V5.2C21 6.88016 21 7.72024 20.673 8.36197C20.3854 8.92646 19.9265 9.3854 19.362 9.67302C18.7202 10 17.8802 10 16.2 10H16M11 18L7 22V14M7 3V10M4.5 19.5L3 18M19 22V14L16.5 16.5M19 22H21M19 22H17M21 4V4C21 2.89543 20.1046 2 19 2H18C16.8954 2 16 2.89543 16 4V4C16 5.10457 16.8954 6 18 6H19C20.1046 6 21 5.10457 21 4Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M21 4V5.2C21 6.88016 21 7.72024 20.673 8.36197C20.3854 8.92646 19.9265 9.3854 19.362 9.67302C18.7202 10 17.8802 10 16.2 10H16M7 22L3 18M7 22L11 18M7 22V14M7 3V10M19 22V14L16.5 16.5M19 22H21M19 22H17M21 4V4C21 2.89543 20.1046 2 19 2H18C16.8954 2 16 2.89543 16 4V4C16 5.10457 16.8954 6 18 6H19C20.1046 6 21 5.10457 21 4Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M21 4V5.2C21 6.88016 21 7.72024 20.673 8.36197C20.3854 8.92646 19.9265 9.3854 19.362 9.67302C18.7202 10 17.8802 10 16.2 10H16M7 22L3 18M7 22L11 18M7 22V14M7 3V10M19 22V14L16.5 16.5M19 22H21M19 22H17M21 4V4C21 2.89543 20.1046 2 19 2H18C16.8954 2 16 2.89543 16 4V4C16 5.10457 16.8954 6 18 6H19C20.1046 6 21 5.10457 21 4Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
